<template>
  <layout-private  :customer="customer">
      <div class="row">

        <div v-if="customer" class="col-12">
          <h1 class="title-short">Team <span v-if="!Object.keys(groups).length || !locations || !roles"><i class="far fa-fw fa-pulse fa-spinner"></i></span></h1>
        </div> <!-- /.col-x -->

        <div class="col-12">
          <hr class="hr-header" />
        </div>
        
        <div class="col-12 col-filters-header">
          <div class="row">
            <div class="col-6"><p class="light-weight"><em>Sort &amp; Filter:</em></p></div>
            <div class="col-6 text-right"><p><button @click="clearFilters" class="btn btn-link">clear filters</button></p></div>
          </div>
        </div>

        <div v-if="users && Object.keys(users).length" class="col-filters col-12">
          <div class="row row-filters">
            <div class="col-filters-sort col col-6 col-xl-2">
              <select v-model="sortBy" class="form-control form-control-sm">
                <option default value="name">Sort by Name</option>
                <option value="caughtUp">Sort by Caught Up Date</option>
              </select>
            </div> <!-- /sort -->
            <div class="col-filters-search col col-6 col-xl-auto">
              <input v-model="searchText" class="form-control form-control-sm" id="searchText" type="text" name="searchText" placeholder="Search name/email" />
            </div> <!-- /email/name -->
            <div v-if="groups && Object.keys(groups).length" class="col-filters-group  col-6 col-xl-3 row">
              <div :class="[{'col-6': filterGroup},{'col-12': !filterGroup}]">
                <select v-model="filterGroupId" class="form-control form-control-sm">
                  <option :value="null">All Groups</option>
                  <option value="none">No Group</option>
                  <option v-for="group in groups" :value="group.id">{{ group.groupName }}</option>
                </select>
              </div>
              <div class="col-6" v-if="filterGroup">
                <select v-model="filterLocationId" class="form-control form-control-sm">
                  <option :value="null">All Locations</option>
                  <option v-for="location in filterGroup.locations" :value="location.id">{{ location.locationName }}</option>
                </select>
              </div>
            </div> <!-- /groups -->
            <div v-if="roles && Object.keys(roles).length" class="col-filters-role col col-6 col-xl-auto">
              <select v-model="filterRoleId" class="form-control form-control-sm">
                <option :value="null">All Roles</option>
                <option value="none">No Role</option>
                <option v-for="role in roles" :value="role.id">{{ role.roleName }}</option>
              </select>
            </div> <!-- /roles -->
            <div v-if="adminLevels && adminLevels.length" class="col-filters-role col col-6 col-xl-2">
              <select v-model="filterAdminLevel" class="form-control form-control-sm">
                <option :value="null">All Access Levels</option>
                <option value="none">No Access Level</option>
                <option v-for="adminLevel in adminLevels" :value="adminLevel.value">{{ adminLevel.adminLevelName }}</option>
              </select>
            </div> <!-- /access levels -->
            <div class="col-filters-role col col-6 col-xl-auto">
              <select v-model="filterStatus" class="form-control form-control-sm">
                <option :value="null">All Statuses</option>
                <option value="accepted">Accepted</option>
                <option value="invited">Invited</option>
                <option value="not invited">Not Invited</option>
                <option value="hidden">Hidden</option>
              </select>
            </div> <!-- /status -->
          </div> <!-- /.row -->
        </div>

        <div class="col-12">
          <hr class="hr-filters" />
        </div>

        <div v-if="customer && !customer.has_users" class="col-intro text-center col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
          <h4 class="light-weight snug">Getting Started: Step 5 of 5</h4>
          <h2>Invite Team Members</h2>
          <p>Nice work! Last, invite your team members to Smiley.</p>
        </div> <!-- /.col-x -->

        <div class="col-12 col-import" v-if="showImportMultiple || (customer && !customer.has_users)">
          <h3>Invite Team Members</h3>
          <div class="row">
            <div class="col-6">
              <!-- placeholder text must be broken into 2nd line with no tabs -->
              <textarea
                v-model="importText"
                placeholder="george.washington@example.com
benjamin.franklin@example.com"
                class="form-control"></textarea>
            </div>
            <div class="col-6 d-flex flex-wrap align-items-start">
              <p class="col-12"><strong>Instructions:</strong> copy and paste a list of email addresses in the box on the left. You can copy from a spreadsheet, document, or anywhere else! Just make sure each email address is on a separate line and that there are no commas or other separators.</p>
              <p class="col-12 align-self-end text-right">
                <list-errors :errors="errors"></list-errors>
                <button v-if="customer && customer.has_users && !savingUsers" @click="showImportMultiple=false" class="btn btn-link">cancel</button>
                <button @click="importMultipleUsers" :disabled="!importText" v-if="!savingUsers" class="btn btn-app">Import All</button>
                <span v-if="savingUsers"><i class="far fa-fw fa-pulse fa-spinner"></i></span>
              </p>
            </div>
          </div>
        </div> <!-- /.col-x -->

        <div class="col-12" v-if="users && Object.keys(users).length > 0">
          <table class="table table-responsive-lg table-custom table-striped-custom">
            <thead>
              <tr>
                <th><i class="fas fa-edit"></i></th>
                <th>Name</th>
                <th>Email</th>
                <th>Roles</th>
                <th>Access Level</th>
                <th>Locations</th>
                <th>Last Caught Up</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(u, userId) in filteredUsers" :key="userId" v-if="userToEdit !== userId">
                <td class="d-flex">
                  <button v-if="userId !== user.uid" @click="userToEdit=userId;showImportMultiple=false" class="btn btn-link btn-edit"><i class="far fa-edit"></i></button>
                  <router-link v-if="userId !== user.uid && u.provider_code" :to="'/provider/' + userId"  @click="userToEdit=null;showImportMultiple=false" class="btn btn-link btn-stats"><i class="far fa-chart-bar"></i></router-link>
                  <!-- <button v-if="userId !== customer.id && userId !== user.uid" @click="userToEdit=userId;showImportMultiple=false" class="btn btn-link"><i class="far fa-edit"></i></button> -->
                  <!-- <i v-if="userId == customer.id" class="fas fa-lock fa-tooltip fa-tooltip-left"><span class="tip">
                    The account owner can't be edited.
                  </span></i> -->
                  <i v-if="userId == user.uid" class="user-locked far fa-lock fa-tooltip fa-tooltip-left"><span class="tip">
                    You can't edit your own permissions.
                  </span></i>
                </td>
                <td>{{ u.name }}</td>
                <td>{{ u.email }}</td>
                <td>
                  <span v-if="(!u.adminLevel || !u.adminLevel.includes('Admin')) && u.roles && u.roles.length > 0">{{ u.roles.length }}</span>
                  <span v-if="(!u.adminLevel || !u.adminLevel.includes('Admin')) && (!u.roles || u.roles.length == 0)">0</span>
                  <span v-if="u.adminLevel && (u.adminLevel == 'superAdmin' || u.adminLevel.includes('GroupAdmin_'))">all</span>
                </td>
                <td>
                  <span v-if="u.adminLevel && u.status && u.status != 'hidden'">{{ prettyAccessLevel(u.adminLevel) }}</span>
                  <span v-if="u.adminLevel && u.status && u.status == 'hidden'">hidden</span>
                  <span v-if="!u.adminLevel">--</span>
                </td>
                <td>
                  <span v-if="u.locations && u.locations.length > 0 && u.adminLevel !== 'superAdmin'">{{ u.locations.length }}</span>
                  <span v-if="u.adminLevel && u.adminLevel !== 'superAdmin' && (!u.locations || u.locations.length == 0)">0</span>
                  <span v-if="u.adminLevel && u.adminLevel == 'superAdmin'">all</span>
                </td>
                <td>
                  <span v-if="u.caught_up_as_of">{{ u.caught_up_as_of | formatDate }}</span>
                  <span v-if="!u.caught_up_as_of"><em>-</em></span>
                </td>
                <td>
                  <span>{{ u.status }}</span>
                  <span v-if="u.status=='invited' && !u.resent" class="resendStatus"><a @click.prevent="resendInvite(userId)" href="#resend">resend</a></span>
                  <span v-if="u.resent" class="resendStatus"><i class="far fa-check color-"></i> resent</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div> <!-- /.col-x -->

        <div class="col-12">
          <hr />
        </div>

        <div class="col-12 col-lg-3">
          <p>
            <button v-if="!showImportMultiple" @click.prevent="showImportMultiple=true" class="btn btn-app btn-icon-left"><i class="far fa-list-alt"></i>Import Email Addresses</button>
          </p>
        </div>
        <div class="col-12 col-lg-3 text-lg-right order-lg-3">
          <p>
            <span v-if="savingUsers"><i class="far fa-fw fa-pulse fa-spinner"></i></span>
            <button :disabled="savingUsers || !users || !Object.values(users).some(u => u.status == 'not invited')" @click.prevent="inviteTeam" class="btn btn-app btn-green btn-icon-left"><i class="far fa-envelope"></i>Invite Team to Smiley</button>
          </p>
        </div>
        <div class="col-12 col-lg-6 text-lg-center order-lg-2">
          <p class="sm"><em>How invitations work: after importing, click "Invite Team" to send an email invitation to all team members who haven't signed up and haven't been invited yet.</em></p>
        </div>

        <div v-if="userToEdit" class="modal modal-app" tabindex="-1">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row row-edit-user box-blue">
                  <div class="col-name col-lg-4">
                    <label>Name <i v-if="users[userToEdit].status !== 'not invited'" class="sm light-weight">only the user can edit</i></label>
                    <input v-model="users[userToEdit].name" name="name" :disabled="users[userToEdit].status !== 'not invited'" placeholder="Enter display name" class="form-control" type="text" />
                  </div>
                  <div class="col-email col-lg-4">
                    <label>Email Address <i v-if="users[userToEdit].status !== 'not invited'" class="sm light-weight">only the user can edit</i></label>
                    <input v-model="users[userToEdit].email" :disabled="users[userToEdit].status !== 'not invited'" name="email" placeholder="Enter email" class="form-control" type="email" />
                  </div>
                  <div class="col-access col-lg-4">
                    <div v-if="users[userToEdit].status == 'accepted'">
                      <label>
                        Access Level
                        <i class="far fa-info-circle fa-tooltip"><span class="tip">
                          <ul class="list-unstyled">
                            <li><strong>Super Admin:</strong> change billing, post in all groups, roles, locations, &amp; use admin website</li>
                            <li><strong>Group Admin:</strong> post in own group &amp; all roles</li>
                            <li><strong>Mobile Only:</strong> view locations &amp; roles assigned, post high fives only</li>
                          </ul>
                        </span></i>
                        <i v-if="userToEdit == customer.id" class="sm light-weight"> can't edit for owner</i>
                      </label>
                      <select v-model="users[userToEdit].adminLevel" :disabled="userToEdit == customer.id" class="form-control">
                        <option disabled :value="null">Choose Access Level</option>
                        <option v-for="adminLevel in adminLevels" :value="adminLevel.value">{{ adminLevel.adminLevelName }}</option>
                      </select>
                    </div>
                    <div v-if="users[userToEdit].status !== 'accepted'">
                      <label>Access Level</label>
                      <p class="small"><em>You can set an access level after the user accepts their invitation. Default: mobile only.</em></p>
                    </div>
                  </div>
                  <div class="col-role col-lg-4">
                    <label>Roles</label>
                    <select v-model="userNewRoleId" @change="addUserRole(userToEdit, $event)" class="form-control">
                      <option disabled :value="null">Add a Role</option>
                      <option v-for="role in roles" :value="role.id" :disabled="role.hidden">
                        {{ role.roleName }}<span v-if="role.hidden"> (hidden)</span>
                      </option>
                    </select>
                    <ul v-if="users[userToEdit].roles && users[userToEdit].roles.length" class="list-unstyled list-remove">
                      <li v-for="role in users[userToEdit].roles"><button @click="removeUserRole(userToEdit,role)" class="btn btn-link"><i class="far fa-times"></i></button> <span>{{ roles[role].roleName }}<em v-if="roles[role].hidden"> (hidden)</em></span></li>
                    </ul>
                  </div>
                  <div class="col-loc col-lg-4">
                    <label>Locations</label>
                    <select v-model="userNewLocationId" @change="addUserLocation(userToEdit, $event)" class="form-control">
                      <option disabled :value="null">Add a Location</option>
                      <option v-for="location in locations" :value="location.id" :disabled="location.user_count >= customer.user_limit || location.hidden">
                        {{ location.locationName }}
                        <span v-if="location.user_count >= customer.user_limit">(Disabled: user limit reached)</span>
                        <span v-if="location.hidden"> (hidden)</span>
                      </option>
                    </select>
                    <ul v-if="users[userToEdit].locations && users[userToEdit].locations.length" class="list-unstyled list-remove">
                      <li v-for="loc in users[userToEdit].locations" class="row row-location-list justify-content-between align-items-center">
                        <span v-if="users[userToEdit].primary_location && users[userToEdit].primary_location == loc" class="badge badge-dark badge-tiny"><i class="fas fa-star"></i>primary</span>
                        <span class="flex-grow-1">{{ locations[loc].locationName }}<em v-if="locations[loc].hidden"> (hidden)</em></span>
                        <button v-if="!users[userToEdit].primary_location || users[userToEdit].primary_location !== loc" @click="setUserPrimaryLocation(userToEdit,loc)" class="btn btn-link btn-pl"><i class="far fa-star"></i></button>
                        <button @click="removeUserLocation(userToEdit,loc)" class="btn btn-link btn-rl"><i class="far fa-times"></i></button>
                      </li>
                    </ul>
                  </div>
                  <div class="col-badge col-lg-4">
                    <label>Badge</label>
                    <button class="form-select-custom" @click="showBadgeSelect=!showBadgeSelect">
                      <span v-if="users[userToEdit].badge_level || users[userToEdit].badge_level==0" class="selected">
                        <badge :badge="badges[users[userToEdit].badge_level]" :size="'sm'" :disableTooltip="true"></badge>
                        {{ badges[users[userToEdit].badge_level].badge_name }}
                      </span>
                      <span v-if="!users[userToEdit].badge_level && users[userToEdit].badge_level!==0" class="selected">Choose badge</span>
                      <span v-if="showBadgeSelect" class="select-list">
                        <button v-for="badge in badges" @click="users[userToEdit].badge_level = badge.badge_level" class="select-option">
                          <badge :badge="badge" :size="'sm'" :disableTooltip="true"></badge>
                          {{ badge.badge_name }}
                        </button>
                      </span>
                    </button>
                    <!-- <select v-model="users[userToEdit].badge_level" class="form-control">
                      <option disabled :value="null">Choose Badge</option>
                      <option v-for="badge in badges" :value="badge.badge_level">
                        <badge :badge="badge" :size="'sm'" :disableTooltip="true"></badge>
                        {{ badge.badge_name }}
                      </option>
                    </select> -->
                  </div>
                  <div class="col-provider col-lg-4">
                    <label>
                      OpenDental Provider Code <span class="light-weight">(optional)</span>
                      <i class="far fa-fw fa-info-circle fa-tooltip"><span class="tip">
                        Enter the Open Dental provider code (Provider Abbreviation). This will enable provider stats for this user. Only available to users who have accepted their invite to Smiley.
                      </span></i>
                    </label>
                    <input v-model="users[userToEdit].provider_code" name="providerCode" placeholder="Enter abbreviation" class="form-control" type="email" />
                    <label v-if="users[userToEdit].provider_code && users[userToEdit].provider_code.trim().length" class="normal-weight form-check">
                      <input :disabled="!users[userToEdit].provider_code" type="checkbox" name="isHYG" v-model="users[userToEdit].provider_is_hyg" :value="users[userToEdit].provider_is_hyg" class="form-check-input">
                      <small>this provider is a hygienist</small>
                    </label>
                  </div>
                  <div class="col-settings col-lg-4">
                    <label>Settings</label><br>
                    <button v-if="users[userToEdit].status !== 'accepted' && users[userToEdit].status !== 'hidden' && users[userToEdit].status !== 'hidden'" @click="deleteUser(userToEdit)" class="btn btn-link"><i class="far fa-times"></i>Delete User</button>
                    <button
                      class="btn btn-hide btn-icon-only btn-no-animation"
                      v-if="userToEdit && users[userToEdit] && (users[userToEdit].status == 'accepted' || users[userToEdit].status == 'hidden')"
                      @click="toggleHideUser(userToEdit)"
                    >
                      <i v-if="users[userToEdit].status !== 'hidden' && !users[userToEdit].savingHiddenState" class="far fa-eye fa-tooltip"><span class="tip">
                        This user is visible. Click to hide in Smiley mobile and block their access to Smiley.
                      </span></i>
                      <i v-if="users[userToEdit].status == 'hidden' && !users[userToEdit].savingHiddenState" class="far fa-eye-slash fa-tooltip "><span class="tip">
                        This user is hidden. Click to re-enable their access to Smiley.
                      </span></i>
                      <i v-if="users[userToEdit].savingHiddenState" class="far fa-fw fa-pulse fa-spinner"></i>
                    </button>
                  </div>
                  <div class="col-footer col-lg-4 d-flex justify-content-between align-items-end">
                    <p class="snug">
                      <span v-if="savingUser"><i class="far fa-fw fa-pulse fa-spinner"></i></span>
                    </p>
                    <p class="snug">
                      <button v-if="!savingUser" @click="userToEdit=null;userErrors=[]" class="btn btn-link">cancel</button>
                      <button @click="updateUser" v-if="!savingUser" class="btn btn-app">Save Changes</button>
                    </p>
                  </div>
                  <div class="col-errors col-12">
                    <list-errors :errors="userErrors"></list-errors>
                  </div>
                </div> <!-- /.row -->
              </div>
            </div>
          </div>
        </div> <!-- /.modal -->
        <div v-if="userToEdit" class="modal-backdrop"></div>

      </div> <!-- /.row -->
  </layout-private>
</template>

<script>
import Vue from 'vue'
import LayoutPrivate from '../components/LayoutPrivate.vue'
import {mapGetters} from 'vuex'
import ListErrors from '../components/ListErrors.vue'
import Badge from '../components/Badge.vue'

export default {
  props: ['customer'],
  components: {
    LayoutPrivate, ListErrors, Badge,
  },
  data () {
    return {
      errors: [],
      userErrors: [], // used for saving updates to single user
      loading: false,
      savingUsers: false, // loading indicator for saving multiple users
      savingUser: false, // loading indicator for saving single user
      success: false,
      users: {}, // objects of objects are only reactive if set with this.$set(this.users, id, value)
      groups: {},
      roles: {},
      locations: {}, // store all locations separately so can get a full list easily
      badges: null,
      showImportMultiple: false, // toggle import modal
      importText: null, // raw list of email addresses to process
      showBadgeSelect: false,
      // user currently editing
      userToEdit: null,
      // placeholders to make select inputs in user edit box function
      userNewLocationId: null,
      userNewRoleId: null,
      //filters
      searchText: null,
      filterGroupId: null,
      filterLocationId: null,
      filterRoleId: null,
      filterAdminLevel: null,
      filterStatus: null,
      sortBy: 'name',
    }
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims']),
    filterGroup() {
      if(this.groups && Object.keys(this.groups).length && this.filterGroupId && this.groups[this.filterGroupId]) {
        return this.groups[this.filterGroupId];
      }
      return null;
    },
    adminLevels() {
      let adminLevelsArray = [
        {adminLevelName: "Super Admin", value: "superAdmin"},
        {adminLevelName: "Mobile Only", value: "mobileOnly"},
      ]
      if(this.groups && Object.keys(this.groups).length) {
        Object.values(this.groups).forEach(group => {
          if(!group.hidden) {
            adminLevelsArray.push({
              adminLevelName: "Group Admin: " + group.groupName,
              value: `GroupAdmin_${group.id}`,
            })
          }
        })
      }
      return adminLevelsArray;
    },
    filteredUsers() {
      let filtered = Object.entries(this.users);

      // -----
      // search name & email
      // -----
      if(this.searchText) {
        filtered = filtered.filter(([userId,user]) => {
          // when creating regex, the beginning and ending / are added automatically
          let regex = new RegExp(this.searchText,'i');
          // console.log('regex',regex);
          // check name & email separately so it doesn't have to be in both
          if(user.email) {
            let emailMatch = user.email.match(regex);
            // console.log('emailMatch',emailMatch);
            if(emailMatch && emailMatch.length) {
              return [userId,user];
            }
          }
          if(user.name) {
            let nameMatch = user.name.match(regex);
            // console.log('nameMatch',nameMatch);
            if(nameMatch && nameMatch.length) {
              return [userId,user];
            }
          }
        });
        // console.log('searchText filtered', filtered);
      }
      // -----
      // filter by group
      // -----
      if(this.filterGroupId) {
        if(this.filterGroupId == "none") {
          filtered = filtered.filter(([userId,user]) => {
            if(!user.locations || !user.locations.length) {
              return [userId,user];
            }
          });
        }
        // filter by location if it's selected
        else if(this.filterLocationId) {
          filtered = filtered.filter(([userId,user]) => {
            if(user.locations && user.locations.some(loc => loc == this.filterLocationId)) {
              return [userId,user];
            }
          });
        }
        // else filter just by group
        else {
          filtered = filtered.filter(([userId,user]) => {
            let includedUser;
            // loop through the selected group's locations and look for them
            this.filterGroup.locations.forEach(location => {
              if(user.locations && user.locations.some(loc => loc == location.id)) {
                // return as key pair if found
                  // cannot return here, would only exit the forEach loop,
                  // so store in var to return after loop
                includedUser = [userId,user];
              }
            });
            return includedUser;
          });
        }
        // console.log('group filtered', filtered);
      }
      // -----
      // filter by role
      // -----
      if(this.filterRoleId) {
        if(this.filterRoleId == "none") {
          filtered = filtered.filter(([userId,user]) => {
            if(!user.roles || !user.roles.length) {
              return [userId,user];
            }
          });
        } else {
          filtered = filtered.filter(([userId,user]) => {
            if(user.roles && user.roles.some(role => role == this.filterRoleId)) {
              return [userId,user];
            }
          });
        }
        // console.log('role filtered', filtered);
      }
      // -----
      // filter by admin level
      // -----
      if(this.filterAdminLevel) {
        if(this.filterAdminLevel == "none") {
          filtered = filtered.filter(([userId,user]) => {
            if(!user.adminLevel) {
              return [userId,user];
            }
          });
        } else {
          filtered = filtered.filter(([userId,user]) => {
            if(user.adminLevel == this.filterAdminLevel) {
              return [userId,user];
            }
          });
        }
        // console.log('role filtered', filtered);
      }
      // -----
      // filter by status
      // -----
      if(this.filterStatus) {
        filtered = filtered.filter(([userId,user]) => {
          if(user.status == this.filterStatus) {
            return [userId,user];
          }
        });
        // console.log('role filtered', filtered);
      }
      // -----
      // sort
      // -----
      // console.log('pre sort', filtered);
      if(this.sortBy == 'name') {
        // console.log('name')
        filtered = filtered.sort((prev,next) => {
          if(!next[1].name) {
            return -1;
          }
          if(!prev[1].name) {
            return 1;
          }
          // ascending
          // can't compare strings with subtraction here
          if(prev[1].name.toUpperCase() < next[1].name.toUpperCase()) {
            return -1;
          }
          if(prev[1].name.toUpperCase() > next[1].name.toUpperCase()) {
            return 1;
          }
          return 0;
        });
      } else if(this.sortBy == 'caughtUp') {
        console.log('caughtUp')
        filtered = filtered.sort((prev,next) => {
          if(!next[1].caught_up_as_of) {
            return -1;
          }
          if(!prev[1].caught_up_as_of) {
            return 1;
          }
          // descending - show most out-dated first
            // convert to dates and get timestamps to sort correctly
            // and prevent 20230903 from being greater than 20230929
          let nextDate = next[1].caught_up_as_of;
          let nextDateArr = [nextDate.slice(0,4), nextDate.slice(4,6)-1, nextDate.slice(6)];
          let prevDate = prev[1].caught_up_as_of;
          let prevDateArr = [prevDate.slice(0,4), prevDate.slice(4,6)-1, prevDate.slice(6)];
          return new Date(...nextDateArr).getTime() - new Date(...prevDateArr).getTime();
        });
      }
      // console.log('post sort', filtered);
      // -----
      // return the object
      // -----
      return Object.fromEntries(filtered);
    },
  },
  watch: {
    customer() {
      this.checkCustomer();
    },
    // check for redirect on loading custom claims
    custom_claims() {
      if(!this.custom_claims || !this.custom_claims.adminLevel || this.custom_claims.adminLevel !== "superAdmin") {
        this.$router.replace('/')
      }
    },
  },
  methods: {
    clearFilters () {
      this.searchText = null;
      this.filterGroupId = null;
      this.filterLocationId = null;
      this.filterRoleId = null;
      this.filterAdminLevel = null;
      this.filterStatus = null;
      this.sortBy = 'name';
    },
    // require customer object to view page
    checkCustomer() {
      if(this.customer) {
        if(!Object.keys(this.groups).length) this.loadGroupsLocations();
        if(!Object.keys(this.users).length) this.loadUsers();
        if(!Object.keys(this.roles).length) this.loadRoles();
        this.loadBadges();
      }
    },
    prettyAccessLevel(adminLevel) {
      if(adminLevel == "superAdmin") return "Super Admin";
      if(adminLevel == "mobileOnly") return "Mobile Only";
      if(adminLevel.includes("GroupAdmin_")) {
        const groupId = adminLevel.split("_")[1];
        let groupAdminOf = this.groups[groupId];
        if(groupId && groupAdminOf) {
          return `Group Admin: ${groupAdminOf.groupName}`;
        }
      }
      return '--';
    },
    resendInvite(userId) {
      if(userId) {
        Vue.firestore.doc(`email/${userId}`)
          .update({
            'delivery.state': 'RETRY',
          })
          .then(() => {
            // add propery with reactivity
            this.$set(this.users[userId], 'resent', true);
            // this.users[userId].resent = true;
          })
          .catch(err => console.log(err));
      }
    },
    addUserRole (userId, event) {
      // console.log(`add role ${event.target.value} to user ${userId}`)
      if(this.users && this.users[userId]) {
        if(this.users[userId].roles) {
          if(!this.users[userId].roles.some(role => role == event.target.value)) {
            this.users[userId].roles.push(event.target.value);
          }
        } else {
          this.users[userId].roles = [`${event.target.value}`];
        }
        // reset value on next tick
        this.$nextTick(()=>{
          this.userNewRoleId = null;
          // console.log('this.userNewRoleId',this.userNewRoleId)
        })
      }
    },
    removeUserRole (userId, roleId) {
      // console.log(`rm role ${roleId} from user ${userId}`)
      if(this.users && this.users[userId] && this.users[userId].roles && this.users[userId].roles.some(role => role == roleId)) {
        let roleIndex = this.users[userId].roles.indexOf(roleId);
        // console.log({roleIndex})
        let newRolesArray = this.users[userId].roles;
        newRolesArray.splice(roleIndex,1);
        // must use $set to make reactive since locations are stores in an object
        this.$set(this.users, userId, {
          ...this.users[userId],
          roles: newRolesArray, // setting a 2nd time after the ... overwrites it
        })
      }
    },
    addUserLocation (userId, event) {
      // use event.target.value instead of userNewLocationId, which is too slow
      // console.log(`add location ${event.target.value} to user ${userId}`)
      // locations stored as array of ids for querying
        // previous versions stored as array of objects or object of objects but weren't queryable

      // save location to user
      if(this.users && this.users[userId]) {
        if(this.users[userId].locations) {
          if(!this.users[userId].locations.some(loc => loc == event.target.value)) {
            this.users[userId].locations.push(event.target.value);
          }
        } else {
          this.users[userId].locations = [event.target.value];
        }
        // reset value on next tick
        this.$nextTick(()=>{
          this.userNewLocationId = null;
          // console.log('this.userNewLocationId',this.userNewLocationId)
        })
      }
    },
    removeUserLocation (userId, locationId) {
      // console.log(`rm location ${locationId} from user ${userId}`)
      if(this.users && this.users[userId] && this.users[userId].locations && this.users[userId].locations.some(loc => loc == locationId)) {
        let locIndex = this.users[userId].locations.indexOf(locationId);
        // console.log({locIndex})
        let newLocArray = this.users[userId].locations;
        newLocArray.splice(locIndex,1);
        // check if it's the primary location, and if so, clear their primary location
        let primaryLoc = null;
        let primaryLocRemoved = null;
        if(this.users[userId].primary_location) {
          primaryLoc = this.users[userId].primary_location;
          if(primaryLoc == locationId) {
            primaryLoc = null;
            primaryLocRemoved = true;
          }
        }
        // must use $set to make reactive since locations are stores in an object
        this.$set(this.users, userId, {
          ...this.users[userId],
          // setting a 2nd time after the ... overwrites it
          locations: newLocArray,
          primary_location: primaryLoc,
          primary_location_removed: primaryLocRemoved,
        })
      }
    },
    setUserPrimaryLocation (userId, locationId) {
      console.log(`set primary location ${locationId} for user ${userId}`)
      if(this.users && this.users[userId] && this.users[userId].locations && this.users[userId].locations.some(loc => loc == locationId)) {
        this.$set(this.users, userId, {
          ...this.users[userId],
          primary_location: locationId, // setting a 2nd time after the ... overwrites it
        })
      }
    },
    async deleteUser(userId) {
      if(!userId || !this.users[userId] || this.users[userId].status == 'accepted' || this.users[userId].status == 'hidden') {
        return;
      }
      let userRef = await Vue.firestore.collection('customers')
        .doc(this.customer.id)
        .collection('users')
        .doc(userId)
        .delete()
        .then(() => {
          this.userToEdit = null;
          // delete from object and keep reactive
          this.$delete(this.users, userId);
        })
        .catch(err => console.log(err));
    },
    toggleHideUser(userId) {
      if(this.users[userId].status !== "accepted" &&  this.users[userId].status !== "hidden") {
        console.log('user must be either hidden or active');
        return;
      }
      const newStatus = this.users[userId].status == "accepted" ? "hidden" : "accepted";
      // console.log({newStatus});
      // console.log('toggle hide user',userId);
      // save updates
      this.$set(this.users, userId, {
        ...this.users[userId],
        status: newStatus,
        savingHiddenState: true,
      });
      const update = {
        status: newStatus,
      };
      // open batch changes
      var batch = Vue.firestore.batch();
      // save to customers/users
      let userRef = Vue.firestore.doc(`customers/${this.customer.id}/users/${userId}`);
      batch.update(userRef, update);
      // save to /users
      let userPropsRef = Vue.firestore.doc(`users/${userId}`);
      batch.update(userPropsRef, update);
      // save
      batch.commit()
        .then(() => {
          // console.log('changes saved')
          this.$set(this.users, userId, {
            ...this.users[userId],
            status: newStatus,
            // savingHiddenState: false,
          });
        })
        .catch(err => console.log(err));
    },
    async loadRoles() {
      if(!this.customer) {
        return;
      }
      let newRoles = await Vue.firestore.collection('customers')
        .doc(this.customer.id)
        .collection('roles')
        .get()
        .then(rolesQuerySnap => {
          if(rolesQuerySnap.empty) {
            console.log("couldn't find roles in your account.")
          }
          for(const [i,role] of rolesQuerySnap.docs.entries()) {
            // console.log(role.data(), role.id);
            this.$set(this.roles, role.id, {
              ...role.data(),
              id: role.id,
            });
          }
        })
    },
    async loadUsers() {
      if(!this.customer) {
        return;
      }
      let newUsers = await Vue.firestore.collection('customers')
        .doc(this.customer.id)
        .collection('users')
        .onSnapshot(userQuerySnap => {
          if(userQuerySnap.empty) {
            console.log("couldn't find users in your account.")
          }
          for(const [i,u] of userQuerySnap.docs.entries()) {
            // console.log(u.data(), u.id);
            // store users with id so they can be updated with onSnapshot
            // use $set to make reactive in Vue
            this.$set(this.users, u.id, {
              ...u.data(),
            });
            // delete old user from array after new one added
              // a new user is saved after an invitation is accepted under a new id
              // to match their auth uid
            if(u.oldUserId && this.users[u.oldUserId]) {
              this.$delete(this.users, u.oldUserId );
            }
          }
        })
    },
    async loadGroupsLocations() {
      if(!this.customer || Object.keys(this.groups).length) {
        return false;
      }
      this.errors = [];
      try {
        this.loading = true;
        let groupsQuerySnap = await Vue.firestore.collection('customers')
          .doc(this.customer.id)
          .collection('groups')
          .get();

        // console.log({ groupsQuerySnap });
        if(groupsQuerySnap.empty) {
          console.log("couldn't find location groups in your account.")
          // if none found, set a blank group
          this.groups[0] = {
            groupName: null,
            locations: [{
              locationName: null,
            }],
          };
          this.loading = false;
          return true;
        }
        for(const group of groupsQuerySnap.docs) {
          // console.log(group.data())
          let groupData = {
            ...group.data(),
            id: group.id,
            locations: [],
          }
          this.$set(this.groups, group.id, groupData);
          // onSnapShot is not async so cannnot await it
          group.ref.collection('locations').onSnapshot(locationQuerySnap => {
            // console.log({ locationQuerySnap });
            if(locationQuerySnap.empty) {
              throw new Error("Error: couldn't find locations in your account.")
            }
            for(const [i,location] of locationQuerySnap.docs.entries()) {
              // console.log(location.data(), location.id);
              // store locations with id
              this.$set(this.groups[group.id].locations, i, {
                ...location.data(),
                id: location.id,
              });
              // store 2nd copy so easy to get a list of all locations
              this.$set(this.locations, location.id, {
                ...location.data(),
                id: location.id,
                groupId: group.id,
              });
            }
            this.loading = false;
          });
        }
      } catch(err) {
        this.errors.push(err.message)
        console.log(err);
      }
    },
    loadBadges() {
      // load badges from firestore, save to this.badges, overwrite default badge
      if(this.custom_claims && this.custom_claims.customerId) {
        Vue.firestore.doc(`customers/${this.custom_claims.customerId}/settings/badges`)
        .get()
        .then(badgesSnap => {
          // console.log(badgesSnap.data());
          if(badgesSnap.exists && badgesSnap.data().badges_list && badgesSnap.data().badges_list.length) {
            this.badges = badgesSnap.data().badges_list;
          }
        })
      }
    },
    importMultipleUsers() {
      this.errors = [];
      this.savingUsers = true;
      const importArr = this.importText.trim().split('\n');
      if(!this.importText) {
        this.errors.push('Oops, you must enter email addresses to import.')
      }
      if(this.importText.includes(',') || this.importText.includes(';')) {
        this.errors.push('Please enter emails on separate lines. Commas are not allowed.')
      }
      if(!this.importText.indexOf('@')) {
        this.errors.push('No valid email addresses found.')
      }
      if(!this.importText.trim().length) {
        this.errors.push('Email addresses cannot be only spaces.')
      }
      // from: https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
      const emailRegex = /^\S+@\S+\.\S+$/;
      if(importArr.some(e => !emailRegex.test(e))) {
        this.errors.push('An email address is not formatted correctly.')
      }
      // validate no duplicates
      const emailSet = new Set(importArr);
      // delete undefined values, caused by Array.map not returning a value
        // for each role that has role.include == false
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map#mapped_array_contains_undefined
      emailSet.delete(undefined);
      // console.log(emailSet)
      if(emailSet.size < importArr.length) {
        this.errors.push("Oops, there are duplicate emails listed.")
      }
      // validate none already exist if adding a 2nd time
      if(this.users && Object.keys(this.users).length > 0) {
        const allEmails = new Set(importArr);
        let currentUserEmails = Object.values(this.users).map(user => user.email);
        // can only add 1 value to a set at a time
        currentUserEmails.forEach(email => allEmails.add(email));
        allEmails.delete(undefined);
        // console.log({allEmails})
        if(allEmails.size < (importArr.length + Object.keys(this.users).length)) {
          this.errors.push("Oops, one or more of these emails were added previously.")
        }
      }
      if(this.errors.length) {
        this.savingUsers = false;
        return;
      }

      // save users and invitations
      var batch = Vue.firestore.batch();

      // save all emails
      importArr.forEach(email => {
        // create user in customer users subcollection
        let ref = Vue.firestore.collection('customers')
          .doc(this.customer.id)
          .collection('users')
          .doc(); // sets auto-generated id since batch.add() is not valid
        batch.set(ref, {
          email: email,
          customerId: this.customer.id,
          status: 'not invited',
          invitedBy: this.user.email,
        });
      });
      // save a flag to show we have users
      if(!this.customer.has_users) {
        let ref = Vue.firestore.collection('customers')
          .doc(this.customer.id);
        batch.update(ref, {
          has_users: true,
        });
      }

      batch.commit()
      .then(() => {
        this.importText = null;
        this.savingUsers = false;
        this.showImportMultiple = false;
      })
      .catch((err) => {
        this.errors.push(`An error occured: ${err.message}`);
        console.log(err);
      });
    },
    updateUser() {
      this.userErrors = [];
      this.savingUser = true;

      if(!this.customer) {
        return;
      }

      if(!this.userToEdit || !this.users || !this.users[this.userToEdit]) {
        this.userErrors.push('Oops, no user to save');
      }

      const updatedUser = this.users[this.userToEdit];
      // console.log({updatedUser})

      if(updatedUser.name && (!updatedUser.name.trim().length || updatedUser.name.trim().length < 3)) {
        this.userErrors.push('User name cannot be only spaces and must be 3 or more characters.')
      }
      if(!updatedUser.email.trim().length) {
        this.userErrors.push('Email cannot be only spaces.')
      }
      // from: https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
      const emailRegex = /^\S+@\S+\.\S+$/;
      if(!emailRegex.test(updatedUser.email)) {
        this.userErrors.push('Email address is not formatted correctly.')
      }
      // if primary location exists, make sure it's in location list
      if(updatedUser.primary_location && !updatedUser.locations.some(loc => loc == updatedUser.primary_location)) {
        this.userErrors.push("User's primary location must be included in location list")
      }
      // if provider code set, validate length
      if(updatedUser.provider_code && (!updatedUser.provider_code.trim().length || updatedUser.provider_code.trim().length < 3)) {
        this.userErrors.push('Provider Code cannot be only spaces and must be 3 or more characters.')
      }
      // stop if errors exist
      if(this.userErrors.length) {
        this.savingUser = false;
        return;
      }
      // continue after validation passed
      var batch = Vue.firestore.batch();

      // save user
      let userRef = Vue.firestore.collection('customers')
        .doc(this.customer.id)
        .collection('users')
        .doc(this.userToEdit);
      let userUpdates = {
        name: updatedUser.name || null,
        locations: updatedUser.locations || null,
        roles: updatedUser.roles || null,
        provider_code: updatedUser.provider_code || null,
        provider_is_hyg: updatedUser.provider_is_hyg || null,
      };
      // add badge level to update object if it exists
      if(updatedUser.badge_level || updatedUser.badge_level==0) {
        userUpdates.badge_level = updatedUser.badge_level;
      }
      // add primary location to update object if it exists
      if(updatedUser.primary_location) {
        userUpdates.primary_location = updatedUser.primary_location;
      }
      // remove primary location if it was removed from locations list
      if(!updatedUser.primary_location && updatedUser.primary_location_removed) {
        userUpdates.primary_location = null;
      }
      // only update email if user hasn't already accepted
      if(updatedUser.status !== "accepted") {
        userUpdates.email = updatedUser.email || null;
      }
      // save user custom claims
        // if not account owner
      if(updatedUser.status == "accepted" && this.userToEdit !== this.customer.id) {
        userUpdates.adminLevel = updatedUser.adminLevel || null;
      }
      batch.update(userRef, userUpdates);

      let userPropsRef = Vue.firestore.collection('users').doc(this.userToEdit);

      // update user props if a badge_level is present
        // only if user status == accepted, otherwise the user_props node doesn't exist
      if(updatedUser.status == "accepted" && (updatedUser.badge_level || updatedUser.badge_level==0)) {
        batch.update(userPropsRef, {
          badge_level: updatedUser.badge_level,
        });
      }

      // update user props if a primary_location is present
        // only if user status == accepted, otherwise the user_props node doesn't exist
      if(updatedUser.status == "accepted" && updatedUser.primary_location) {
        batch.update(userPropsRef, {
          primary_location: updatedUser.primary_location,
        });
      }

      // update user props if primary_location removed
        // only if user status == accepted, otherwise the user_props node doesn't exist
      if(updatedUser.status == "accepted" && !updatedUser.primary_location && updatedUser.primary_location_removed) {
        batch.update(userPropsRef, {
          primary_location: null,
        });
      }

      batch.commit()
      .then(() => {
        this.savingUser = false;
        this.userToEdit = null;
      })
      .catch((err) => {
        this.userErrors.push(`An error occured: ${err.message}`);
        console.log(err);
      });

    },
    inviteTeam() {

      // exit if no uninvited users
      if(!this.users) {
        return;
      }
      let usersArr = Object.values(this.users);
      if(!usersArr.length || !usersArr.some(u => u.status == "not invited")) {
        return;
      }

      this.savingUsers = true;
      var inviteAccountUsers = Vue.functions.httpsCallable('inviteAccountUsers');
      inviteAccountUsers({ customerId: this.customer.id})
        .then(result => {
          // cloud function will update the db, so results will show as changed status on users in table
          console.log("inviteAccountUsers result:",result);
          this.savingUsers = false;
        })
        .catch(err => {
          this.errors.push(err.message)
          this.savingUsers = false;
          console.log(err);
        });
    },
  },
  mounted () {
    // this.checkCustomer(); // if check here will always redirect away on page refresh
    this.loadGroupsLocations();
    this.loadUsers();
    this.loadRoles();
    this.loadBadges();
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.row-filters {
  > div {
    background-color: #f9f9f9;
    padding: 5px;
    // margin: 0 5px;
    border: 2px solid #fff;
    border-radius: 5px;
  }
  @media (min-width: @screen-lg-min) {
    // reset back to .col settings
    .col-xl-auto {
      flex: 0 1 auto;
      max-width: 100%;
    }
  }
}
.col-filters-header .btn-link {
  vertical-align: baseline;
  font-weight: 300 !important;
}
.col-filters {
  .form-control {
    margin: 0;
  }
  .col-filters-group {
    margin: 0;
    .col-12 {
      padding: 0;
    }
    .col-6:first-child {
      padding-left: 0;
      padding-right: 5px;
    }
    .col-6:last-child {
      padding-right: 0;
      padding-left: 5px;
    }
  }

}
// override for filters row
.hr-header {
  margin-bottom: 30px;
}
.hr-filters {
  margin: 30px 0;
  border-top-color: @dim-color;
}
.col-intro {
  h2 {
    margin-bottom: 10px;
  }
  p:last-child {
    margin-bottom: 40px;
  }
}
.col-import {
  background-color: fadeout(@color-blue, 50%);
  padding: 30px;
  margin-bottom: 40px;

  textarea.form-control {
    height: 330px;
  }
  .btn + .btn {
    margin-left: 20px;
  }
}
table.table {
  margin: 0;

  tbody .btn-link {
    .far {
      margin: 0;
      vertical-align: text-top;
    }
  }
  .btn-link + .btn-link {
    margin-left: 10px;
  }
  tbody tr {
    .btn-edit,
    .btn-stats,
    .user-locked {
      opacity: 0.1;

    }
  }
  tbody tr:hover {
    background-color: fadeout(@color-blue, 50%);

    .btn-edit,
    .btn-stats,
    .user-locked {
      opacity: 1;
    }
  }
}
.row-edit-user {
  background-color: fadeout(@color-blue, 50%);

  > div {
    padding: 30px 30px 0;
  }
  .col-errors {
    padding: 0 30px 30px;
  }
  .form-control {
    margin: 0;
  }
  .list-remove {
    margin: 20px 0 0;
  }
  .btn-link + .btn-app {
    margin-left: 20px;
  }
  .row-location-list {
    margin-left: 0;
    margin-right: 0;
  }
  .badge.badge-tiny {
    margin: 1px 3px 0 0;

    .fas {
      margin-right: 2px;
    }
  }
}
ul.list-unstyled,
ul.list-unstyled li:last-child {
  margin: 0;
}
.resendStatus {
  margin-left: 5px;
}
</style>
